import { gql } from "apollo-boost"

export const createDocuments = gql`
  mutation CreateDocuments($data: [DocumentsSubmissionInput!]!) {
    CreateDocuments(data: $data)
  }
`


export const createBalance =  gql`
  mutation Mutation($data: CreateExpenseReconciliationInput!) {
  AddExpenseReconciliation(data: $data)
}
`

export const deleteBalance = gql`
  mutation Mutation($accountNumber: String!, $submission: ID!, $month: String!) {
  DeleteExpenseReconciliation(account_number: $accountNumber, submission: $submission, month: $month)
}
`